/**
 * Builds query string for GET /api/admin/activity-logs (and /acciones-sistema).
 * Empty or whitespace-only values are omitted; undefined/null filter properties are treated as blank.
 * @param {{
 *   tipo?: string | null;
 *   recurso?: string | null;
 *   ejecutadoPor?: string | null;
 *   desde?: string | null;
 *   hasta?: string | null;
 *   limit?: string | number | null;
 *   offset?: string | number | null;
 * }} [filters]
 * @returns {string}
 */
export function buildActivityLogQueryString(filters) {
  const base =
    filters != null && typeof filters === "object" && !Array.isArray(filters)
      ? filters
      : {};

  const params = new URLSearchParams();

  setIfNonEmpty(params, "tipo", trimOrEmpty(base.tipo));
  setIfNonEmpty(params, "recurso", trimOrEmpty(base.recurso));
  setIfNonEmpty(params, "ejecutadoPor", trimOrEmpty(base.ejecutadoPor));
  setIfNonEmpty(params, "desde", trimOrEmpty(base.desde));
  setIfNonEmpty(params, "hasta", trimOrEmpty(base.hasta));

  const limitStr = normalizeLimit(base.limit);
  if (limitStr) params.set("limit", limitStr);

  const offsetStr = normalizeOffset(base.offset);
  if (offsetStr && offsetStr !== "0") params.set("offset", offsetStr);

  return params.toString();
}

/**
 * @param {unknown} value
 * @returns {string}
 */
function trimOrEmpty(value) {
  return typeof value === "string" ? value.trim() : "";
}

/**
 * @param {URLSearchParams} params
 * @param {string} key
 * @param {string} value
 */
function setIfNonEmpty(params, key, value) {
  if (value) params.set(key, value);
}

/**
 * @param {unknown} raw
 * @returns {string}
 */
function normalizeLimit(raw) {
  if (typeof raw === "number" && Number.isFinite(raw)) {
    return String(Math.max(1, Math.floor(raw)));
  }
  if (typeof raw === "string") {
    const n = Number.parseInt(raw.trim(), 10);
    if (Number.isFinite(n) && n >= 1) {
      return String(n);
    }
  }
  return "";
}

/**
 * @param {unknown} raw
 * @returns {string} empty when invalid or non-integer string
 */
function normalizeOffset(raw) {
  if (typeof raw === "number" && Number.isFinite(raw)) {
    return String(Math.max(0, Math.floor(raw)));
  }
  if (typeof raw === "string") {
    const t = raw.trim();
    if (t === "") {
      return "";
    }
    if (!/^\d+$/.test(t)) {
      return "";
    }
    const n = Number.parseInt(t, 10);
    if (!Number.isFinite(n) || n < 0) {
      return "";
    }
    return String(n);
  }
  return "";
}
